var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollections = function SvgCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240 172"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M120.151 170.499c-45.658 0-82.801-37.145-82.801-82.801 0-45.658 37.143-82.803 82.801-82.803s82.801 37.145 82.801 82.803c0 45.656-37.142 82.801-82.801 82.801m0-164.706c-45.161 0-81.903 36.742-81.903 81.904S74.991 169.6 120.151 169.6c45.162 0 81.904-36.742 81.904-81.903S165.313 5.793 120.151 5.793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "m164.038 117.665 29.732 29.728-.636.635-29.732-29.727z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M197.363 157.013h-.005a5.86 5.86 0 0 1-5.855-5.854 5.8 5.8 0 0 1 1.714-4.142 5.8 5.8 0 0 1 4.142-1.718 5.865 5.865 0 0 1 5.857 5.86 5.86 5.86 0 0 1-5.853 5.854m-.005-10.816a4.92 4.92 0 0 0-3.508 1.454 4.9 4.9 0 0 0-1.448 3.506 4.964 4.964 0 0 0 4.956 4.958h.005a4.96 4.96 0 0 0 4.954-4.957 4.965 4.965 0 0 0-4.959-4.961M59.59 12.554l40.287 40.281-.635.635-40.287-40.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M55.771 14.712a5.864 5.864 0 0 1-5.856-5.86 5.8 5.8 0 0 1 1.713-4.137A5.8 5.8 0 0 1 55.762 3c3.237 0 5.864 2.625 5.864 5.852a5.82 5.82 0 0 1-1.713 4.145 5.82 5.82 0 0 1-4.142 1.715m-.002-10.814a4.92 4.92 0 0 0-3.507 1.453 4.92 4.92 0 0 0-1.449 3.501 4.966 4.966 0 0 0 4.958 4.962c1.324 0 2.57-.517 3.506-1.453a4.92 4.92 0 0 0 1.451-3.509 4.963 4.963 0 0 0-4.959-4.954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections_svg__a",
    x1: 58.781,
    x2: 153.963,
    y1: 88.833,
    y2: 151.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections_svg__a)",
    d: "M144.509 135.613H79.288c-5.445 0-9.881-4.434-9.881-9.882V77.074c0-5.447 4.436-9.88 9.881-9.88v3.593a6.295 6.295 0 0 0-6.287 6.288v48.657a6.295 6.295 0 0 0 6.287 6.288h65.221a6.295 6.295 0 0 0 6.287-6.288h3.594c0 5.448-4.435 9.881-9.881 9.881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections_svg__b",
    x1: 70.701,
    x2: 149.733,
    y1: 77.952,
    y2: 143.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections_svg__b)",
    d: "M153.257 126.865H88.035c-5.445 0-9.88-4.433-9.88-9.88V68.327c0-5.448 4.436-9.881 9.88-9.881v3.593a6.295 6.295 0 0 0-6.287 6.288v48.658a6.296 6.296 0 0 0 6.287 6.288h65.222a6.294 6.294 0 0 0 6.286-6.288h3.595c0 5.448-4.436 9.88-9.881 9.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections_svg__c",
    x1: 89.549,
    x2: 179.221,
    y1: 54.455,
    y2: 122.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections_svg__c)",
    d: "M161.062 49.552H95.839c-5.445 0-9.882 4.433-9.882 9.88v48.66c0 5.447 4.437 9.88 9.882 9.88h65.222c5.447 0 9.879-4.433 9.879-9.88v-48.66c0-5.447-4.431-9.88-9.878-9.88m-44.271 64.827H95.839a6.296 6.296 0 0 1-6.288-6.287v-11.86l14.207-14.204c2.375-2.373 6.516-2.373 8.891-.001l18.247 18.245zm50.557-11.947v5.661a6.294 6.294 0 0 1-6.286 6.287H121.87l12.625-12.628 11.642-11.639c2.371-2.374 6.516-2.374 8.893-.002zm-9.781-14.862a9.8 9.8 0 0 0-1.543-1.257c-.062-.042-.136-.067-.203-.109a9.7 9.7 0 0 0-1.52-.799q-.017-.003-.034-.01a9.9 9.9 0 0 0-3.684-.715 9.9 9.9 0 0 0-3.612.692c-.034.016-.077.021-.115.036a10 10 0 0 0-1.46.767c-.084.054-.179.085-.263.142a10 10 0 0 0-1.538 1.255l-10.16 10.16-18.245-18.246a9.82 9.82 0 0 0-6.986-2.891 9.8 9.8 0 0 0-6.985 2.893L89.551 91.151V59.432a6.295 6.295 0 0 1 6.288-6.287h65.222a6.293 6.293 0 0 1 6.286 6.287v37.919z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "collections_svg__d",
    x1: 95.75,
    x2: 185.419,
    y1: 46.226,
    y2: 113.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#faaf40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f05a28"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collections_svg__d)",
    d: "M135.288 65.366c-5.87 0-10.646 4.775-10.646 10.646s4.775 10.646 10.646 10.646c5.866 0 10.643-4.774 10.643-10.646 0-5.871-4.777-10.646-10.643-10.646m0 17.697c-3.889 0-7.053-3.163-7.053-7.052s3.164-7.053 7.053-7.053 7.05 3.164 7.05 7.053-3.162 7.052-7.05 7.052"
  })));
};
export default SvgCollections;